// const BASE_URL = `https://helpdesk-app-server.onrender.com`;
// const BASE_URL = `http://localhost:5000`;
const BASE_URL = `https://help-desk-app.onrender.com`;
export { BASE_URL };
